import React, { useEffect } from "react";
import PodBox from "pod-box-sdk";

import configs from "../configs";
import { LoadingAnimation, CenterizedPage } from "../components";

export const Init = () => {
  useEffect(() => {
    PodBox.init({
      clientId: configs.CLIENT_ID,
      redirectUri: configs.REDIRECT_URL,
      scope:
        "profile+email+wallet_balance:read&response_type=token&access_type=offline&include_granted_scopes=true",
    });
  }, []);
  return (
    <CenterizedPage>
      <LoadingAnimation size="6rem" />
    </CenterizedPage>
  );
};
